/**
 * Brand CTA Aside - Shown when a brand views a creator profile (not owner).
 * LinkedIn-inspired right rail on desktop; full-width below header on mobile.
 * Button shows "Coming soon" inline (no backend yet).
 */

import React, { useState } from 'react';

const BrandCTAAside = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const handleContactClick = (e) => {
    e.preventDefault();
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 4000);
  };

  return (
    <aside
      className="w-full lg:w-80 flex-shrink-0 no-print"
      aria-label="Contact creator for collaboration"
    >
      <div className="lg:sticky lg:top-20 rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="text-base font-semibold text-slate-900">
          Like this influencer?
        </h3>
        <p className="mt-2 text-sm text-slate-600">
          Contact them for a collab and request rates, availability, and brand fit.
        </p>
        <div className="mt-4">
          <button
            type="button"
            onClick={handleContactClick}
            className="w-full inline-flex justify-center items-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 transition-colors"
          >
            Contact for collaboration
          </button>
          {showComingSoon && (
            <p className="mt-2 text-sm text-slate-500 text-center" role="status">
              Coming soon
            </p>
          )}
        </div>
      </div>
    </aside>
  );
};

export default BrandCTAAside;
